import { z } from "zod";

function normalizeIrlPostcode(value: string) {
  return value.replace(/\s+/g, "").toUpperCase();
}

const irlPostcodePattern = /^([AC-FHKNPRTV-Y]\d{2}|D6W)[0-9AC-FHKNPRTV-Y]{4}$/;

function isValidIrlPostcode(value: string) {
  return irlPostcodePattern.test(normalizeIrlPostcode(value));
}

const irlPostcode = z
  .string()
  .min(1, { message: "Postcode is required" })
  .refine(isValidIrlPostcode, {
    message: "Must be a valid Eircode",
  });

export { irlPostcode, isValidIrlPostcode, normalizeIrlPostcode };
